import { render, staticRenderFns } from "./ShishiyuqingDetail.vue?vue&type=template&id=a1b6e24c&scoped=true&"
import script from "./ShishiyuqingDetail.vue?vue&type=script&lang=js&"
export * from "./ShishiyuqingDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShishiyuqingDetail.vue?vue&type=style&index=0&id=a1b6e24c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b6e24c",
  null
  
)

export default component.exports